// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './filters'

Vue.config.productionTip = false;
Vue.mixin({
  created: function () {
    let $baseUrl = "http://localhost:5000";
    let $userId = "";
    let $token = "";
  }
});
// Vue plugins
import VueTranslate from 'vue-translate-plugin';
import { TableComponent, TableColumn } from 'vue-table-component';
import DateTime from 'vue-datetime';
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker';
import FileUpload from 'vue-upload-component';
import ToggleButton from 'vue-js-toggle-button';
import VueI18n from 'vue-i18n';
import Notifications from 'vue-notification';
import VueSimplemde from 'vue-simplemde';
import 'simplemde/dist/simplemde.min.css';
import VueMarkdown from 'vue-markdown'

Vue.component('table-component', TableComponent);
Vue.component('table-column', TableColumn);
Vue.component('v-select', vSelect);
Vue.component('date-range-picker', DateRangePicker);
Vue.component('file-upload', FileUpload);
Vue.component('vue-markdown', VueMarkdown);

Vue.use(DateTime);
Vue.use(VueTranslate);
Vue.use(VueCharts);
Vue.use(ToggleButton);
Vue.use(VueI18n);
Vue.use(Notifications);
Vue.use(VueSimplemde);
Vue.use(require('vue-prevent-parent-scroll'));

const i18n = new VueI18n({
  locale: 'nl',
  messages: {
    'nl': require('./assets/translations/nl-nl'),
    'en': require('./assets/translations/en-en'),
    'de': require('./assets/translations/de-de'),
    'fr': require('./assets/translations/fr-fr'),
    'es': require('./assets/translations/es-es'),
    'pt': require('./assets/translations/pt-pt'),
    'it': require('./assets/translations/it-it'),
    'cn': require('./assets/translations/cn-cn')
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js